<template>
  <v-container class="home-container">
    <categorias-home v-if="!$isMobile()"></categorias-home>
    <categorias-home-mobile v-else></categorias-home-mobile>
  </v-container>
</template>

<script>
import CategoriasHome from '../components/CategoriasHome.vue'
import CategoriasHomeMobile from '../components/mobile/NewCategoriasHomeMobile.vue'
import { mapActions } from 'vuex'

export default {
  components: { CategoriasHome, CategoriasHomeMobile },
  name: 'Home',
  methods: {
    ...mapActions('Categorias', ['getCategorias'])
  },
  async beforeRouteUpdate (to, from, next) {
    // Cuando cambia el parámetro client, limpiar y recargar datos
    if (to.params.client !== from.params.client) {
      // Limpiar cache
      this.$store.commit('Productos/setProducts', [])
      this.$store.commit('Categorias/setCategoria', null)
      this.$store.commit('Categorias/setCategorias', [])
      // Recargar categorías para el nuevo cliente
      await this.getCategorias()
    }
    next()
  },
  watch: {
    '$route.params.client': {
      handler: async function (newClient, oldClient) {
        // Si cambia el cliente, recargar categorías (respaldo para casos donde beforeRouteUpdate no se ejecute)
        if (newClient && newClient !== oldClient) {
          this.$store.commit('Productos/setProducts', [])
          this.$store.commit('Categorias/setCategoria', null)
          this.$store.commit('Categorias/setCategorias', [])
          await this.getCategorias()
        }
      },
      immediate: false
    }
  },
  mounted () {
    this.$emit('showCart', true)
  }
}
</script>
